import loadImage from 'blueimp-load-image'
import 'blueimp-canvas-to-blob/js/canvas-to-blob'
import { History } from '../constants'

export const addZero = (num: string | number) => (+num < 10 ? '0' + num : num)

export const isFileTypeImage = (target: string) =>
  ['image/jpeg', 'image/jpg', 'image/png'].includes(target)

export const convertDateToString = (date: Date | string, isToday?: boolean) => {
  const dateObj = new Date(date)
  if (isToday) {
    return `${addZero(dateObj.getHours())}:${addZero(dateObj.getMinutes())}`
  } else {
    return `${addZero(dateObj.getDate())}/${addZero(
      dateObj.getMonth() + 1
    )} om ${addZero(dateObj.getHours())}:${addZero(dateObj.getMinutes())}`
  }
}

function fixRotationOfFile(file: any) {
  return new Promise((resolve, reject) => {
    loadImage(
      file,
      (img: { toBlob: (arg0: (blob: any) => void, arg1: string) => void }) => {
        if (img.toBlob) {
          img.toBlob(function (blob) {
            resolve(blob)
          }, 'image/jpeg')
        } else {
          reject('blob not working')
        }
      },
      { orientation: true, canvas: true }
    )
  })
}

export const fixRotation = async (arrayOfFiles: any[]) => {
  for (let i = 0; i < arrayOfFiles.length; i++) {
    arrayOfFiles[i] = await fixRotationOfFile(arrayOfFiles[i])
  }
  return arrayOfFiles
}

export function checkIsBase64(
  str: string | string[] | Partial<History> | null
) {
  const notBase64 = /[^A-Z0-9+/=]/i
  const isString = typeof str === 'string' || str instanceof String

  if (!isString) {
    let invalidType
    if (str === null) {
      invalidType = 'null'
    } else {
      invalidType = typeof str
      if (
        invalidType === 'object' &&
        str.constructor &&
        str.constructor.hasOwnProperty('name')
      ) {
        invalidType = str.constructor.name
      } else {
        invalidType = `a ${invalidType}`
      }
    }
    throw new TypeError(`Expected string but received ${invalidType}.`)
  }

  const len = str.length
  if (!len || len % 4 !== 0 || notBase64.test(str as string)) {
    return false
  }
  const firstPaddingChar = str.indexOf('=')
  return (
    firstPaddingChar === -1 ||
    firstPaddingChar === len - 1 ||
    (firstPaddingChar === len - 2 && str[len - 1] === '=')
  )
}

export const removeMime = (str: string | null | undefined) =>
  str?.replace(/data:\w*\/\w*;base64,/gm, '')

const findElementPosition = (element: {
  offsetParent: any
  offsetLeft: number
  offsetTop: number
  x: any
  y: any
}) => {
  if (typeof element.offsetParent != 'undefined') {
    for (var posX = 0, posY = 0; element; element = element.offsetParent) {
      posX += element.offsetLeft
      posY += element.offsetTop
    }
    return [posX, posY]
  } else {
    return [element.x, element.y]
  }
}

export const getCoordinates = (event: any) => {
  let posX = 0
  let posY = 0
  let imgPos
  imgPos = findElementPosition(event.target)
  if (!event) {
    event = window.event
  }
  if (event.pageX || event.pageY) {
    posX = event.pageX
    posY = event.pageY
  } else if (event.clientX || event.clientY) {
    posX =
      event.clientX +
      document.body.scrollLeft +
      document.documentElement.scrollLeft
    posY =
      event.clientY +
      document.body.scrollTop +
      document.documentElement.scrollTop
  }
  posX = posX - imgPos[0]
  posY = posY - imgPos[1]
  return [posX, posY]
}

export const convertSvgToBase64 = async (svg: string) => {
  return `data:image/svg+xml;base64, ${window.btoa(svg)}`
}

export const getSidePhotoKey = (sideName: string): string => {
  return `photo${sideName.charAt(0).toUpperCase() + sideName.slice(1)}`
}

export const fileToBase64 = (file: File): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = () => {
      const result = reader.result as string
      const base64 = result.replace(/data:[^;]+;base64,/, '')
      resolve(base64)
    }
    reader.onerror = reject
    reader.readAsDataURL(file)
  })

export const fileListToBase64Array = async (
  files: FileList | null
): Promise<string[]> => {
  if (!files || files.length === 0) return []
  const arr = Array.from(files)
  const results = await Promise.all(arr.map(fileToBase64))
  return results
}
